<template>
	<div class="MapGuide_container">
		<div class="MapGuide_content">
			<div class="MapGuide_content_top">
				<img draggable="false" src="../assets/periphery_top.png" />
			</div>
			<div class="News_content_swiper">
				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<img draggable="false" src="../assets/MapGuide_one.png" />
						</div>
						<div class="swiper-slide">
							<img draggable="false" src="../assets/MapGuide_two.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="MapGuide_content_botom">
				<img v-show="false" draggable="false" src="../assets/periphery_bottomOne.png" />
				<img draggable="false" src="../assets/periphery_bottomTwo.png" />
			</div>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	var mySwiper = null;
	export default {
		name: 'MapGuide',
		data() {
			return {

			}
		},
		methods: {
			carousel() {
				var that = this;
				mySwiper = new Swiper('.swiper-container', {
					loop: true,
					// 如果需要分页器
					pagination: '.swiper-pagination',
					paginationClickable: true,
					autoplayDisableOnInteraction: false,
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					scrollbarDragggable: true
				})
			}
		},
		mounted() {
			var that = this;
			that.$nextTick(function() {
				that.carousel();
			})
		}
	}
</script>

<style scoped>
	.MapGuide_container {
		height: 100vh;
		background: url(../assets/CulturalRelic.png) center center no-repeat;
		background-size: 100% 100%;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.MapGuide_top {
		width: 90%;
		padding: 20px 5%;
	}
	
	.MapGuide_top div:nth-child(1) {
		text-align: center;
		color: white;
		font-size: 45px;
		line-height: 130px;
	}
	
	.MapGuide_content {
		width: 90%;
		height: 87vh;
		position: relative;
		background: white;
		padding: 30px 2%;
	}
	
	.MapGuide_content img {
		width: 100%;
		height: 100%;
	}
	
	.MapGuide_content_top {
		width: 45%;
		margin: 0 auto 30px;
	}
	
	.MapGuide_content_top img {
		width: 100%;
	}
	
	.MapGuide_content_botom {
		width: 80%;
		display: flex;
		justify-content: center;
		margin: 80px auto;
		align-items: center;
	}
	
	.MapGuide_content_botom img {
		width: 45%;
	}
	
	.MapGuide_list {
		width: 70%;
		position: absolute;
		left: 15%;
		top: 45.3%;
		display: flex;
		justify-content: space-between;
	}
	
	.MapGuide_text {
		width: 25%;
		border: 1px solid rgba(161, 42, 23, 1);
		border-radius: 12px;
		font-size: 38px;
		color: #A12A17;
		text-align: center;
		line-height: 60px;
	}
	
	.MapGuide_text_cli {
		width: 25%;
		border: 1px solid rgba(161, 42, 23, 1);
		border-radius: 12px;
		font-size: 38px;
		color: white;
		text-align: center;
		line-height: 60px;
		background: #A12A17;
	}
	.News_content_swiper{
		width: 100%;
	}
	.News_content_swiper img{
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/mapGuide.vue